import React from "react";

/**
 * PhoneMockup — smartphone frame wrapper for landing showcase.
 */
export const PhoneMockup = ({ children, label, className = "" }) => {
  return (
    <div className={`flex flex-col items-center ${className}`} data-testid="phone-mockup">
      <div className="relative">
        {/* Outer frame */}
        <div
          className="relative bg-[#0A0B0D] border border-[#2E2F33] rounded-[42px] p-3 shadow-[0_30px_80px_-20px_rgba(201,162,39,0.15),0_0_0_1px_rgba(201,162,39,0.08)]"
          style={{ width: 280 }}
        >
          {/* Screen */}
          <div
            className="relative bg-[#0D0E10] rounded-[32px] overflow-hidden"
            style={{ height: 570 }}
          >
            {/* Notch */}
            <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-6 bg-black rounded-full z-10 flex items-center justify-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-[#1C1D20]" />
              <div className="w-1.5 h-1.5 rounded-full bg-[#1C1D20]" />
            </div>
            {/* Status bar */}
            <div className="absolute top-3.5 left-4 right-4 flex items-center justify-between z-10 text-[9px] font-body text-[#A0A0A5]">
              <span>9:41</span>
              <span className="flex items-center gap-1">
                <span>•••</span>
                <span className="tracking-wider">100%</span>
              </span>
            </div>

            <div className="pt-8 h-full overflow-hidden">{children}</div>
          </div>
        </div>
        {/* Side buttons */}
        <div className="absolute -left-[3px] top-24 w-[3px] h-8 bg-[#2E2F33] rounded-l" />
        <div className="absolute -left-[3px] top-40 w-[3px] h-12 bg-[#2E2F33] rounded-l" />
        <div className="absolute -right-[3px] top-32 w-[3px] h-16 bg-[#2E2F33] rounded-r" />
      </div>
      {label && (
        <p className="mt-6 text-xs uppercase tracking-brand font-display text-[#A0A0A5]">
          {label}
        </p>
      )}
    </div>
  );
};

export default PhoneMockup;
